var methodSubscriptions = new Map();
var eventSubscriptions = new Map();

var getDomainServiceName = function getDomainServiceName(domain, serviceName) {
  return "".concat(domain, "-").concat(serviceName);
};

export function addMethodSubscriptions(domain, serviceName, addMethodsCallback) {
  var key = getDomainServiceName(domain, serviceName);
  var subscriptionIds = addMethodsCallback();
  methodSubscriptions.set(key, subscriptionIds);
}
export function removeMethodSubscriptions(domain, serviceName, removeMethodsCallback) {
  var key = getDomainServiceName(domain, serviceName);
  var subscriptionIds = methodSubscriptions.get(key) || [];
  subscriptionIds.forEach(removeMethodsCallback);
  methodSubscriptions.delete(key);
}
export function addEventSubscription(topic, addEventCallback) {
  var eventSubscription = eventSubscriptions.get(topic);

  if (eventSubscription) {
    eventSubscription.count += 1;
  } else {
    var _id = addEventCallback();

    eventSubscriptions.set(topic, {
      id: _id,
      count: 1
    });
  }
}
export function removeEventSubscription(topic, removeEventCallback) {
  var subscription = eventSubscriptions.get(topic);

  if (subscription) {
    subscription.count -= 1;

    if (subscription.count === 0) {
      eventSubscriptions.delete(topic);
      removeEventCallback(subscription.id);
    }
  }
}
//# sourceMappingURL=subscriptions.js.map